import { filterDOMProps } from '@react-aria/utils'
import Styles from './Heading.module.scss'
import { factory, Factory } from 'almanac-ui/factory'
import * as CSS from 'csstype'
import cx from 'classnames'

export type HeadingLevel = 1 | 2 | 3 | 4 | 5

export interface HeadingProps {
  level: HeadingLevel
  children: React.ReactNode
  lineClamp?: number
  color?: string | null | false
}

export type HeadingFactory = Factory<{
  props: HeadingProps
  ref: HTMLHeadingElement
}>

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5'

export const Heading = factory<HeadingFactory>(({ level, children, lineClamp, color, ...otherProps }, ref) => {
  const Tag: HeadingTag = (['h1', 'h2', 'h3', 'h4', 'h5'][level - 1] || 'h1') as HeadingTag
  const domProps = filterDOMProps(otherProps)
  const style: CSS.Properties = {
    ['--lines-to-clamp' as any]: lineClamp,
    color: color || undefined,
  }

  return (
    <Tag
      className={cx(Styles.root, {
        [Styles.lineClamp]: lineClamp && lineClamp > 1,
        [Styles.lineClampForceSingleLine]: lineClamp === 1,
      })}
      style={style}
      {...domProps}
      ref={ref}
      data-no-editor-style
    >
      {children}
    </Tag>
  )
})
